import { createSlice } from "@reduxjs/toolkit";
import { User } from "types/index";

export interface UserSlice {
  isInitialized: boolean;
  isLoggedIn: boolean;
  user: User;
}

const initialState: UserSlice = {
  isLoggedIn: false,
  isInitialized: false,
  user: {
    name: null,
    email: null,
    mobile: null,
    date_of_birth: null,
    gender: null,
    location: null,
    username: null,
    image: null,
    is_verified: false,
    is_email_verified: false,
    roles: [],
    member: {
      idx: "",
      code: "",
      available_points: 0,
      is_verified: false,
    },
    cinema_company: {
      idx: "",
      name: "",
    },
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserState(state) {
      return {
        ...state,
        ...initialState,
      };
    },
    logInUser(state, action) {
      return {
        ...state,
        user: action.payload.user,
        isLoggedIn: true,
        isInitialized: true,
      };
    },
    logOutUser(state) {
      return {
        ...state,
        ...initialState,
        isLoggedIn: false,
        isInitialized: true,
      };
    },
    updateUserProfile(state, action) {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    },
  },
  // extraReducers: (builder) => {
  //   builder.addMatcher(
  //     userAPI.endpoints.getUserProfile.matchFulfilled,
  //     (state, action) => {
  //       console.log("action.payload", action.payload);
  //     },
  //   );
  // },
});

export const logInAction = userSlice.actions.logInUser;
export const logOutAction = userSlice.actions.logOutUser;
export const updateUserProfileAction = userSlice.actions.updateUserProfile;
export const resetUserStateAction = userSlice.actions.resetUserState;
